import { futuraNextCondensedExtraBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import EventBandDetails from "./EventBandDetails";
import EventDateBox from "./EventDateBox";
import EventDateTimeLink from "./EventDateTimeLink";

export default function EventEntry({ events }) {
  return (
    <>
      {events?.map((event) => (
        <Grid container key={event.id} sx={eventEntryStyles(events)}>
          <Grid item xs={3} sm={2} md={2.5} lg={2.5} xl={2}>
            <EventDateBox event={event} />
          </Grid>
          <Grid item xs={9} sm={8} md={9.5} lg={9.5} xl={10}>
            <Grid container className="event-entry-content">
              <Grid item xs={12}>
                <Typography className="event-name">{event.name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  {event.bands?.map((band, index) => (
                    <EventBandDetails key={band.id} band={band} />
                  ))}
                  <Grid
                    item
                    xs={12}
                    sx={{ mt: 1, display: { xs: "none", lg: "block" } }}
                  >
                    <EventDateTimeLink event={event} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ padding: "0.5rem", display: { lg: "none" } }}
          >
            <EventDateTimeLink event={event} />
          </Grid>
        </Grid>
      ))}
    </>
  );
}

const eventEntryStyles = (events) => ({
  backgroundColor: "#EEEEEE",
  transition: "background-color 0.3s ease-in-out",
  marginBottom: "1rem",
  "&:hover": {
    backgroundColor: "#E6E6E6",
  },

  "& .event-entry-content": {
    padding: "0.5rem",
    [theme.breakpoints.up("md")]: {
      padding: "1rem",
    },
  },

  "& .event-name": {
    textWrap: "balance",
    fontFamily: futuraNextCondensedExtraBold.style.fontFamily,
    fontWeight: futuraNextCondensedExtraBold.style.fontWeight,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    marginBottom: "0.25rem",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.25rem",
      marginBottom: "0.5rem",
    },
  },
});
